import React from 'react';
import { classNames } from '@geerd-nx/utils';
import { WorkspaceQuery } from '@geerd-nx/shareable-graphql';
export interface WorkspacesSelectorProps {
  workspaceIds: number[];
  workspaces: WorkspaceQuery['workspace'];
  setWorkspaceIds: React.Dispatch<React.SetStateAction<number[]>>;
}

export function WorkspacesSelector(props: WorkspacesSelectorProps) {
  const { workspaceIds, setWorkspaceIds, workspaces } = props;
  return (
    <div className="bg-white p-5 flex items-center">
      <span className="text-sm font-medium text-gray-700 mr-5">
        Select at least one workspace
      </span>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
        {React.Children.toArray(
          workspaces.map((option) => (
            <div
              onClick={() => {
                !workspaceIds.includes(option.id)
                  ? setWorkspaceIds((prevState) => [...prevState, option.id])
                  : setWorkspaceIds((prevState) => {
                      const stateToSave = prevState.filter(function (item) {
                        return item !== option.id;
                      });

                      return stateToSave;
                    });
              }}
              className={classNames(
                workspaceIds.includes(option.id)
                  ? 'bg-primary-600 border-transparent text-white hover:bg-primary-700'
                  : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50',
                'cursor-pointer focus:outline-none border rounded-md py-3 px-3 flex items-center justify-center text-sm text-center font-medium uppercase sm:flex-1'
              )}
            >
              <span className="truncate" title={option.name}>
                {option.name}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default WorkspacesSelector;
